<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" hasBreadcrumb>
        <template #afterTitle>
          <McButton
            variant="secondary"
            :text="$t('global.back')"
            icon="icon-outline_arrow-left"
            @click="handleBack"
          />
        </template>
      </PageHeader>
    </div>

    <FormulateForm
      ref="customerInfoFormRef"
      v-model="customerInfoFormValues"
      name="customer-info"
      :errors="customerInfoFormErrors"
      @submit="handleSubmit"
      @failed-validation="handleFailedSubmission"
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="card-title mb-0">
          {{ $t('master.form.customer.info') }}
        </h4>

        <div class="d-flex gap-2">
          <McButton
            v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mdc1:read'])"
            class="ms-2"
            variant="secondary"
            text="Riwayat Integrasi"
            icon="icon-large icon-outline_file-text"
            @click="$bvModal.show('integration-log-modal-value-help')"
          />

          <McButton
            variant="secondary"
            :disabled="isSubmitting || !hasChanged"
            :text="$t('global.cancel')"
            icon="icon-outline_close"
            @click="$refs['mc-modal-cancel'].show()"
          />

          <McButton
            variant="primary"
            type="submit"
            :disabled="isSubmitting || !hasChanged"
            :text="$t('global.save')"
            icon="icon-outline_save"
          />
        </div>
      </div>

      <b-card>
        <b-row class="g-0">
          <b-col v-for="(field, idx) in filteredCustomerInfoFields" :key="idx" md="3">
            <FormulateInput
              v-bind="field"
              :disabled="!isAdding && (isLoading || isSubmitting)"
              :initialObject="field?.getInitialObject?.(customerInfoData)"
              :help="field?.validation?.includes('required')"
            />
          </b-col>
        </b-row>
      </b-card>
    </FormulateForm>

    <!-- Informasi Perusahaan -->
    <div class="clearfix mb-3">
      <div class="float-start">
        <h4 class="card-title">
          {{ $t('master.form.customer.addressList') }}
        </h4>
      </div>

      <div class="float-end">
        <McButton
          v-if="filterSelected.length"
          variant="outline-danger"
          class="mx-2"
          icon="icon-outline_trash"
          :text="$t('global.delete')"
          @click="openModalDelete"
        />
        <McButton
          :disabled="!$route.params.id"
          :variant="$route.params.id ? 'primary' : 'light'"
          icon="icon-outline_plus"
          :text="$t('global.addField')"
          @click="newAddress"
        />
      </div>
    </div>
    <b-card>
      <div v-if="hasData" class="row">
        <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
          <h6 v-if="filterSelected.length > 0" class="mc-row-check">
            <span class="badge btn-success">{{ filterSelected.length }}</span>
            {{ $t('global.object.selectedRow') }}
            <a class="color-primary" @click="clearTable">{{ $t('global.action.clearAll') }}</a>
          </h6>
        </div>
        <div class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
          <div class="mc-table-view">
            <p class="mc-label">
              {{ $t('global.action.show') }}
            </p>
            <multiselect
              v-model="show_model"
              :options="show"
              :multiple="true"
              :placeholder="$t('global.allColumn')"
              track-by="label"
              label="label"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </multiselect>
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
                @click="focusSearch"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  ref="searchInput"
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                  @input="searchData"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive my-3 border border-1">
        <template v-if="hasData">
          <b-table
            small
            show-empty
            :fields="visibleAddress"
            :items="$route.params.id ? geofences.data : emptyGeofences"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :busy="$apollo.queries.geofences.loading"
            @filtered="onFiltered"
            @listRes="handleListResponse"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>
            <template #head(check)>
              <div class="form-check">
                <input
                  v-model="selectAll"
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  @input="toggleAll"
                />
              </div>
            </template>
            <template #cell(check)="data">
              <div class="form-check">
                <input
                  v-model="filterSelected"
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.geofenceId"
                  @input="checkTable"
                />
              </div>
            </template>
            <template #cell(fenceName)="data">
              <a href="javascript:void(0)" @click="onRowClicked(data.item)">
                <strong class="text-primary">
                  {{ data.item.fenceName }}
                </strong>
              </a>
            </template>
          </b-table>
        </template>
        <McEmptyState
          v-if="!hasData"
          :title="$t('maintenance.nolist.noData')"
          :desc="$t('master.service.emptyState.desc')"
          class="mt-3"
          :hasButton="false"
        />
      </div>
      <div v-if="hasData" class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t('global.show') }}
              <b-form-select
                v-model="perPage"
                class="form-select form-select-sm"
                size="sm"
                :options="pageOptions"
                :disabled="!$route.params.id"
                @input="changePerPage"
              />
              {{ $t('global.text.data') }}
              <p>
                <strong>
                  {{ $route.params.id ? (totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0) : 0 }}
                </strong>
                &nbsp;-&nbsp;
                <strong>
                  {{ $route.params.id ? Math.min(totalRows, currentPage * perPage) : 0 }}
                </strong>
                &nbsp;{{ $t('global.object.of') }}&nbsp;
                <strong>
                  {{ $route.params.id ? totalRows : 0 }}
                </strong>
                &nbsp;{{ $t('global.text.data') }}
              </p>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="$route.params.id ? (totalRows == null ? rows : totalRows) : 1"
                :per-page="perPage"
                :disabled="!$route.params.id"
                @change="changePage"
              />
            </ul>
          </div>
        </div>
      </div>
    </b-card>

    <div v-if="hasAccessCustomerContract">
      <h4 class="card-title">
        {{ $t('master.form.customer.contractList') }}
      </h4>

      <McTable
        v-show="isTableContractDataAvailable"
        withCard
        searchable
        stickyHeader
        :fields="contractFields"
        :apiClient="contractApiClient"
        :hasCheckbox="false"
        @available-change="handleDataAvailable"
      >
        <template #[`cell(number)`]="{ value, item }">
          <a class="text-primary" target="_blank" rel="noopener" @click="openContract(item.id)" >
            {{item.number}}
          </a>
        </template>
        <template #[`cell(status.name)`]="{ value, item }">
          <span
            v-if="item.status?.color"
            class="__status-dots"
            :style="{ backgroundColor: item.status.color }"
          ></span>
          <span style="color: #344264">{{ value }}</span>
        </template>

         <template #[`cell(expired_date)`]="{ value }">
          <template v-if="value">
            <div>{{ formatIndexDate(value).date }}</div>
            <div class="text-muted">
              {{ formatIndexDate(value).time }}
            </div>
          </template>
          <template v-else>-</template>
        </template>

      </McTable>
      <b-card v-show="!isTableContractDataAvailable">
        <div class="empty-table-container">
          <img style="max-width: 220px;" :src="illustrationPath" alt />
          <strong>{{ $t('maintenance.nolist.noData') }}</strong>
        </div>
      </b-card>
    </div>

    <McEditableTable
      :tableTitle="$t('master.form.customer.contactList')"
      withCard
      searchable
      :apiClient="contactApiClient"
      :fields="contactFields"
      :disabled="isAdding"
      :showNoData="isAdding"
      :limitOptions="[5, 10, 25, 50, 100]"
      :apiErrorMappings="contactApiErrorMappings"
      hasEmptyState
    >
      <template #emptyState>
        <McEmptyState
          :title="$t('maintenance.nolist.noData')"
          :desc="$t('master.service.emptyState.desc')"
          :hasButton="false"
        />
      </template>
    </McEditableTable>

    <McEditableTable
      :tableTitle="$t('master.form.customer.deliveryNote')"
      withCard
      searchable
      :apiClient="deliveryNoteApiClient"
      :fields="deliveryNoteFields"
      :disabled="isAdding"
      :showNoData="isAdding"
      :limitOptions="[5, 10, 25, 50, 100]"
      :apiErrorMappings="deliveryNoteApiErrorMappings"
      hasEmptyState
    >
      <template #emptyState>
        <McEmptyState
          :title="$t('maintenance.nolist.noData')"
          :desc="$t('master.service.emptyState.desc')"
          :hasButton="false"
        />
      </template>
    </McEditableTable>
    <b-modal
      id="mc-modal-cancel"
      ref="mc-modal-cancel"
      class="mc-modal"
      :title="$t('global.action.cancel')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.text.modal.cancelChange') }}
          <strong> {{ $t('master.form.customer.info') }} </strong>?
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.action.no')"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.action.yes')" @click="handleCancel" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- Modal for Delete Confirmation -->
    <b-modal
      id="modal-delete"
      class="mc-modal"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item v-for="address in deleteAddress" :key="address.geofenceId">
            {{ address.fenceName }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.action.cancel')"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.action.yes')" @click="toDelete" />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <IntegrationLogHistoryModal
      v-if="hasAccessAll(['webhook-log-event-md:read', 'webhook-event-du1-mdc1:read'])"
      module="md-customer"
      :identifier="$route.params.id"
    />
  </Layout>
</template>

<script>
// TODO:
// - VALIDATION NPWP
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McEditableTable from '@/components/McEditableTable'
import McButton from '@/components/McButton'
import Multiselect from 'vue-multiselect'
import McEmptyState from '@/components/McEmptyState'
import McTable from '@/components/McTable'
import IntegrationLogHistoryModal from '@/router/views/master/fleet/components/IntegrationLogHistoryModal'
import { Helper, debounce } from '@/mixin/helper'

import customerInfoFields from './lib/fields/customerInfoFields'
import contactFields from './lib/fields/contactFields'
import contractFields from './lib/fields/contractFields'
import deliveryNoteFields from './lib/fields/deliveryNoteFields'
import apiErrorMappings from './lib/constants/api-error-mappings'
import contactApiErrorMappings from './lib/constants/contact-api-error-mappings'
import deliveryNoteApiErrorMappings from './lib/constants/delivery-note-api-error-mappings'

import * as Customer from '@/services/rest-api/lib/customer/customer'
import * as Contact from '@/services/rest-api/lib/customer/contact'
import * as DeliveryNote from '@/services/rest-api/lib/customer/delivery-note'
import * as Contract from '@/services/rest-api/lib/contract/customer-contract'
import { DELETE_ADDRESS, GET_ADDRESS, GET_DETAIL_ADDRESS } from '@/services/api/master/address'

import unmaskFormValues from '@/components/formulate/TextInput/lib/unmaskFormValues'
import maskFormValues from '@/components/formulate/TextInput/lib/maskFormValues'
import { mapGetters } from 'vuex'

import { formatIndexDate } from '@/helpers/tzDate'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McEditableTable,
    McButton,
    Multiselect,
    McEmptyState,
    IntegrationLogHistoryModal,
    McTable,
  },
  mixins: [Helper],
  apollo: {
    geofences: {
      query: GET_ADDRESS,
      manual: true,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            customerId: this.$route.params.id,
            isCustomer: true,
            pagination: {
              page: 1,
              show: 10,
            },
          },
        }
      },
      skip() {
        return !this.$route.params.id
      },
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.geofences.geofences.pagination.total
          this.geofences = data.geofences.geofences

          this.hasData = data.geofences.geofences.data && data.geofences.geofences.data.length > 0
        }
      },
    },
  },
  data() {
    return {
      isSubmitting: false,

      customerInfoFormValues: {},
      customerInfoFormErrors: {},
      invalidFormValues: {},
      customerInfoData: {},
      customerInfoFields: customerInfoFields,

      contactFields: contactFields,
      deliveryNoteFields: deliveryNoteFields,
      contractFields: contractFields,

      contactApiErrorMappings: contactApiErrorMappings,
      deliveryNoteApiErrorMappings: deliveryNoteApiErrorMappings,

      isLoading: true,

      selectAll: false,
      filterSelected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      geofences: [],
      emptyGeofences: [],
      show: [
        { key: 'category', label: 'Kategori Alamat' },
        { key: 'address', label: 'Alamat Lengkap' },
        { key: 'province', label: 'Provinsi' },
        { key: 'city', label: 'Kota' },
      ],
      show_model: null,
      listAddress: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fenceName',
          label: 'Nama Lokasi',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'category',
          label: 'Kategori Alamat',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'address',
          label: 'Alamat Lengkap',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'province',
          label: this.$t('master.list.address.province'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'city',
          label: this.$t('master.list.address.city'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
      deleteAddress: [],
      hasData: false,
      isTableContractDataAvailable: false,
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    filteredCustomerInfoFields() {
      return this.customerInfoFields.filter((field) => {
        if (field?.name === 'mgm_immediate_type') {
          return this.hasFeatureFleetTaskContractMGM
        }

        if (field?.featureFlag === undefined) {
          return true
        }

        return this.getFeatureFlagData(field.featureFlag)?.value
      })
    },
    hasChanged() {
      const parsedData = this.parseCustomerData(this.customerInfoData)
      const [, _hasChanged] = this.filterUnchangedData(this.customerInfoFormValues, parsedData)

      return _hasChanged
    },
    isAdding() {
      return typeof this.$route.params.id === 'undefined'
    },
    contactApiClient() {
      return {
        get: Contact.get(this.$route.params.id),
        show: Contact.show(this.$route.params.id),
        update: Contact.update(this.$route.params.id),
        store: Contact.store(this.$route.params.id),
        delete: Contact.deleteSingle(this.$route.params.id),
      }
    },
    contractApiClient() {
      const filters = 'customer.id eq ' + this.$route.params.id
      let getContract = Contract.getWithFilters(filters)
  
      return {
        get: getContract,
      }
    },
    deliveryNoteApiClient() {
      return {
        get: DeliveryNote.get(this.$route.params.id),
        show: DeliveryNote.show(this.$route.params.id),
        update: DeliveryNote.update(this.$route.params.id),
        store: DeliveryNote.store(this.$route.params.id),
        delete: DeliveryNote.deleteSingle(this.$route.params.id),
      }
    },
    title() {
      return this.isAdding
        ? this.$t('master.form.customer.new')
        : this.$t('master.form.customer.detail')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: 'Pelanggan',
          to: '/master/customer',
        },
        {
          text: this.title,
        },
      ]
    },
    visibleAddress() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)
        return this.listAddress.filter(function (item) {
          return item.key == 'check' || item.key == 'fenceName' || result.includes(item.key)
        })
      } else {
        return this.listAddress
      }
    },
    errorKeys() {
      return Object.keys(this.customerInfoFormErrors)
    },
    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
    hasAccessCustomerContract() {
      return this.hasAccessAll([
        "tms-customer-contract:create",
        "tms-customer-contract:delete",
        "tms-customer-contract:read",
        "tms-customer-contract:update",
      ])
    },
    hasFeatureFleetTaskContractMGM() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data?.features?.fleet_task_contract
    },
  },
  watch: {
    customerInfoFormValues() {
      if (this.errorKeys.length === 0) return

      this.errorKeys.forEach((errorKey) => {
        if (this.invalidFormValues[errorKey] != this.customerInfoFormValues[errorKey]) {
          // delete the field from the state to show errors
          this.$delete(this.customerInfoFormErrors, errorKey)
          this.$delete(this.invalidFormValues, errorKey)
        }
      })

      if (this.errorKeys.length === 0) {
        this.invalidFormValues = {}
      }
    },
  },
  async mounted() {
    if (!this.isAdding) {
      await this.showData()
    }
    this.$apollo.queries.geofences.refetch()
  },
  methods: {
    formatIndexDate,
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    async showData(id = null) {
      this.isLoading = true
      const res = await Customer.show(id ?? this.$route.params.id)
      this.isLoading = false

      if (res.errors) {
        this.$mcToast.error(this.$t('global.inputFormatError'))
        return
      }
      const data = res.data ?? {}

      const parsedData = this.parseCustomerData(data)

      this.customerInfoData = {
        ...data,
        mgm_immediate_type: data.mgm_immediate_type
          ? {
              id: data.mgm_immediate_type,
              name: data.mgm_immediate_type,
            }
          : null,
      }
      this.customerInfoFormValues = { ...parsedData }
      this.$apollo.queries.geofences.refetch()
    },
    // eslint-disable-next-line no-unused-vars
    handleFailedSubmission(errors) {
      this.isSubmitting = false
      return this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    handleSubmit(data) {
      if (this.isSubmitting) {
        this.$mcToast.warning(this.$t('global.alert.text.pleaseWait'))
        return
      }

      const unmaskedData = unmaskFormValues(data, customerInfoFields)

      if (this.isAdding) {
        return this.submitStore(unmaskedData)
      } else {
        return this.submitUpdate(unmaskedData)
      }
    },
    async submitStore(data) {
      this.isSubmitting = true
      const res = await Customer.store(data)

      if (res.errors) {
        this.assignErrors(res)
        this.isSubmitting = false
        return
      }

      const id = res.data?.id
      this.$mcToast.success(this.$t('global.alert.text.saved'))
      this.$router.push({ name: 'Master Customer Update', params: { id } })
      this.isSubmitting = false

      // TECHDEBT: for trimming the form values, move to transform
      await this.$nextTick()
      await this.showData(id)
    },
    async submitUpdate(newData) {
      this.isSubmitting = true

      const parsedData = this.parseCustomerData(this.customerInfoData)
      const [patchData] = this.filterUnchangedData(newData, parsedData)

      // Send empty string when industry_category is null (bruh)
      if (patchData.industry_category_name === null) {
        patchData.industry_category_name = ''
      }

      const res = await Customer.update(this.customerInfoData.id, patchData)

      if (res.errors) {
        this.assignErrors(res)
        this.isSubmitting = false
        return
      }

      await this.showData(this.customerInfoData.id)

      this.isSubmitting = false
      this.$mcToast.success(this.$t('global.alert.text.changed'))
    },
    assignErrors(data) {
      if (data.status === 500) return

      if (data.status === 400) {
        const errorKeys = Object.keys(data.errors)

        // assign to form error
        errorKeys.forEach((errorKey) => {
          const errorMessage =
            apiErrorMappings[errorKey][data.errors[errorKey][0]] ??
            'Terdapat kesalahan format pada input anda'
          this.$set(this.customerInfoFormErrors, errorKey, errorMessage)
        })
      }

      // assign the invalid form values
      this.invalidFormValues = { ...this.customerInfoFormValues }

      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    handleBack() {
      this.$router.push({ name: 'Master Customer' })
    },
    handleCancel() {
      const parsedData = this.parseCustomerData(this.customerInfoData)
      this.customerInfoFormValues = { ...parsedData }
      this.customerInfoFormErrors = {}
      this.invalidFormValues = {}

      this.$refs['mc-modal-cancel'].hide()
    },
    filterUnchangedData(newValue, oldValue) {
      const keys = new Set([...Object.keys(newValue), ...Object.keys(oldValue)])
      const _newValue = {}
      keys.forEach((key) => {
        if (key == 'id') return
        if (this.isAdding && !newValue[key]) return
        if (oldValue[key] == newValue[key]) return
        _newValue[key] = newValue[key]
      })

      const entries = Object.entries(_newValue)
      const hasChanged = entries.length > 0 && entries.every((value) => value)
      return [_newValue, hasChanged]
    },
    parseCustomerData(data) {
      const parsedData = {
        name: data.name,
        email: data.email,
        marketing_user_id: data.marketing_user?.id,
        industry_category_name: data.industry_category?.name,
        npwp: data.npwp,
        phone_number: data.phone_number,
        third_party_id: data.third_party_id,
        mgm_immediate_type: data.mgm_immediate_type,
      }

      if (data.marketing_user == null || data.marketing_user == undefined) {
        delete parsedData.marketing_user_id
      }

      return maskFormValues(parsedData, customerInfoFields)
    },
    searchData: debounce(function () {
      this.onFiltered()
    }, 500),
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      if (this.filter.length > 0 && this.filter.length < 3) return
      this.selectAll = false
      this.currentPage = 1
      this.$apollo.queries.geofences.refetch({
        filter: {
          customerId: this.$route.params.id,
          isCustomer: true,
          search: this.filter,
          pagination: {
            page: 1,
            show: this.perPage,
          },
        },
      })
    },
    changePerPage(perPage) {
      this.perPage = perPage
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            customerId: this.$route.params.id,
            isCustomer: true,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            customerId: this.$route.params.id,
            isCustomer: true,
            search: this.filter,
            pagination: {
              page: 1,
              show: this.perPage,
            },
          },
        })
      }
    },
    changePage(page) {
      this.currentPage = page
      if (this.filter == null) {
        this.$apollo.queries.geofences.refetch({
          filter: {
            customerId: this.$route.params.id,
            isCustomer: true,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      } else {
        this.$apollo.queries.geofences.refetch({
          filter: {
            customerId: this.$route.params.id,
            isCustomer: true,
            search: this.filter,
            pagination: {
              page: this.currentPage,
              show: this.perPage,
            },
          },
        })
      }
    },
    async toggleAll(event) {
      let checked = event.target.checked
      let filterAddress = null
      if (this.filter == null) {
        filterAddress = {
          customerId: this.$route.params.id,
          isCustomer: true,
          pagination: {
            page: 1,
            show: this.totalRows,
          },
        }
      } else {
        filterAddress = {
          search: this.filter,
          customerId: this.$route.params.id,
          isCustomer: true,
          pagination: {
            page: 1,
            show: this.totalRows,
          },
        }
      }
      let address = await this.$apollo.query({
        query: GET_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: filterAddress,
        },
      })

      if (checked) {
        for (let i = 0; i < address.data.geofences.geofences.data.length; i++) {
          this.filterSelected.push(address.data.geofences.geofences.data[i].geofenceId)
        }
        this.filterSelected = [...new Set(this.filterSelected)]
      } else {
        for (let i = 0; i < address.length; i++) {
          let index = this.filterSelected.indexOf(
            address.data.geofences.geofences.data[i].geofenceId
          )
          if (index !== -1) {
            this.filterSelected.splice(index, 1)
          }
        }
      }
    },
    async checkTable(event) {
      let filterAddress = null
      if (this.filter == null) {
        filterAddress = {
          customerId: this.$route.params.id,
          isCustomer: true,
          pagination: {
            page: 1,
            show: this.totalRows,
          },
        }
      } else {
        filterAddress = {
          search: this.filter,
          customerId: this.$route.params.id,
          isCustomer: true,
          pagination: {
            page: 1,
            show: this.totalRows,
          },
        }
      }
      let address = await this.$apollo.query({
        query: GET_ADDRESS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: filterAddress,
        },
      })
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value))
        this.filterSelected = [...new Set(this.filterSelected)]
        let flg = true
        for (let i = 0; i < address.data.geofences.geofences.data.length; i++) {
          let index = this.filterSelected.indexOf(
            address.data.geofences.geofences.data[i].geofenceId
          )
          if (index == -1) {
            flg = false
            break
          }
        }
        if (flg) this.selectAll = true
        else this.selectAll = false
      } else {
        this.selectAll = false
        var index = this.filterSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      }
    },
    clearTable() {
      this.filterSelected = []
      this.selectAll = false
    },
    openModalDelete() {
      for (let i = 0; i < this.filterSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_DETAIL_ADDRESS,
            variables: {
              filter: {
                geofenceId: parseInt(this.filterSelected[i]),
              },
            },
          })
          .then((res) => {
            var isSuccessful = res.data.geofence.isSuccessful
            if (isSuccessful) {
              this.deleteAddress.push(res.data.geofence.geofence)
            }
          })
      }
      this.$bvModal.show('modal-delete')
    },
    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []
      for (let i = 0; i < this.filterSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_ADDRESS,
            variables: {
              input: {
                geofenceId: this.filterSelected[i],
              },
            },
          })
        )
      }

      Promise.all(promises)
        .then((res) => {
          let failed = 0
          res.forEach((item) => {
            if (!item.data.deleteGeofence.isSuccessful) {
              this.$mcToast.error(item.data.deleteGeofence.message)
              failed++
            }
          })
          this.$apollo.queries.geofences.refetch()
          if (res.length > failed) {
            this.$mcToast.success(this.$t('global.alert.text.delete'))
          }
          this.clearTable()
          this.$bvModal.hide('modal-delete')
        })
        .catch((error) => {
          console.log(error)
        })
    },
    resetModal() {
      this.deleteAddress = []
    },
    newAddress() {
      this.$router.push({
        name: 'Master Customer Create Address',
        params: {
          uuid: this.$route.params.id,
        },
        query: {
          customerName: this.customerInfoData.name,
        },
      })
    },
    onRowClicked(item) {
      this.$router.push({
        name: 'Master Customer Update Address',
        params: {
          uuid: this.$route.params.id,
          id: item.geofenceId,
        },
        query: {
          customerName: this.customerInfoData.name,
        },
      })
    },

    handleListResponse(response) {
      this.hasData = response?.data?.paginated_result?.length > 0
    },
    handleDataAvailable(isAvailable) {
      this.isTableContractDataAvailable = isAvailable
    },
    openContract(id) {
      const route = this.$router.resolve({
        name: 'Master Customer Contract Detail',
        params: { contractId: id }
      })

      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.__status-dots {
  display: inline-block;
  margin: auto;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
}
</style>